const federalIdFormatter = federalId =>
  federalId && federalId.length === 9
    ? `${federalId.substring(0, 2)}-${federalId.substring(2)}`
    : '';

export default federalIdFormatter;
